<template>
  <div class="modal-toast col-block" :class="param.type">
    <div class="content" v-html="param.content"></div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-row row-block">
      <div :style="{ flex: 1 }"></div>
      <button v-for="(button, index) in param.buttons || []" :key="index" :class="[button.type + '-button', 'circle-button']" @click="$emit('changeModal', {}, button.result)">
        <span>{{ button.title }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/toast.vue